<script setup>
    import { ref, computed, customRef } from "vue";
    import Client from "../services/client";
    import Helpers from "../utils/helpers";
    import { debounce } from "debounce";

    const videos = ref([]);
    const searchQuery = ref("");
    const loading = ref(false);

    const fetchVideos = async () => {
        loading.value = true;
        videos.value = [];

        try {
            const { data } = await Client.get(`/wp-json/wp/v2/search-videos?${Helpers.encodeGetParams({search: searchQuery.value})}`,
                {
                    headers: { "X-WP-Nonce": window.wp_nonce.nonce },
                }
            );

            videos.value = (data || []).map((item)=> {
                return {
                    title: item.title,
                    link: item.link
                }
            })
        } catch (e) {
            console.error(e);
        } finally {
          loading.value = false;
        }
    };

    const filteredVideoTitles = computed(() => {
        return videos.value.filter((obj) => {
            return (obj.title.toLowerCase().includes(searchQuery.value.toLowerCase()));
        });
    });

    const clearSearch = () => {
        searchQuery.value = "";
    }

    const debounceValue = customRef(() => ({
        get() {
            return searchQuery.value
        },
        set: debounce(value => {
            searchQuery.value = value;
            fetchVideos();
        }, 600)
    }));

    const onClickOutside = () => {
        searchQuery.value = "";
    }
</script>

<template>
    <div
        class="video-search"
        v-click-outside="onClickOutside"
    >
        <i>
            <svg xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" version="1.1" width="16px" height="16px">
                <g transform="matrix(1 0 0 1 -539 -235 )">
                    <path d="M 16 14.63693539165237  L 11.435105774728418 10.062893081761004  L 10.70783304745569 10.062893081761004  L 10.456260720411665 9.81132075471698  C 11.352773013150374 8.773013150371641  11.892510005717554 7.4236706689536875  11.892510005717554 5.946255002858776  C 11.892510005717554 2.662092624356775  9.230417381360777 0  5.946255002858777 0  C 2.6620926243567755 0  0 2.662092624356775  0 5.946255002858776  C 0 9.230417381360775  2.6620926243567755 11.892510005717552  5.946255002858777 11.892510005717552  C 7.423670668953689 11.892510005717552  8.773013150371643 11.35277301315037  9.811320754716983 10.460834762721554  L 10.062893081761008 10.712407089765579  L 10.062893081761008 11.435105774728415  L 14.636935391652374 16  L 16 14.63693539165237  Z M 10.062893081761008 5.946255002858776  C 10.062893081761008 8.219554030874784  8.219554030874786 10.062893081761004  5.946255002858777 10.062893081761004  C 3.6729559748427683 10.062893081761004  1.8296169239565467 8.219554030874784  1.8296169239565467 5.946255002858776  C 1.8296169239565467 3.6729559748427674  3.6729559748427683 1.8296169239565463  5.946255002858777 1.8296169239565463  C 8.219554030874786 1.8296169239565463  10.062893081761008 3.6729559748427674  10.062893081761008 5.946255002858776  Z " fill-rule="nonzero" fill="#aaaaaa" stroke="none" transform="matrix(1 0 0 1 539 235 )"/>
                </g>
            </svg>
        </i>
        <input type="text" v-model="debounceValue" />
        <i
            @click="clearSearch"
            v-if="searchQuery !== ''"
            class="video-search__close"
        >
            <svg
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                width="9px"
                height="9px"
            >
                <g transform="matrix(1 0 0 1 -477 -405 )">
                <path
                    d="M 5.409642857142856 4.5  L 9 0.9096428571428572  L 8.090357142857144 0  L 4.5 3.590357142857143  L 0.9096428571428572 0  L 0 0.9096428571428572  L 3.590357142857143 4.5  L 0 8.090357142857144  L 0.9096428571428572 9  L 4.5 5.409642857142856  L 8.090357142857144 9  L 9 8.090357142857144  L 5.409642857142856 4.5  Z "
                    fill-rule="nonzero"
                    fill="#aaaaaa"
                    stroke="none"
                    transform="matrix(1 0 0 1 477 405 )"
                />
                </g>
            </svg>
        </i>
        <div class="video-search__results">
            <ul
                v-if="searchQuery !== ''"
            >
                <li
                  v-show="loading"
                  class="video-search-loading"
                >
                  Searching...
                </li>

                <li
                    v-for="video in filteredVideoTitles"
                    :key="video.id"
                >
                    <a :href="video['link']">
                        <span v-html="video['title']"></span>
                    </a>
                </li>

                <li
                  v-show="filteredVideoTitles.length < 1 && !loading"
                  class="video-search-error"
                >
                  Sorry, no results found...
                </li>
            </ul>
        </div>
    </div>
</template>
